/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Crisp_Hedgehog_StirInputs */

const en_inclusive_crisp_hedgehog_stir = /** @type {(inputs: Inclusive_Crisp_Hedgehog_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report version not supported`)
};

const de_inclusive_crisp_hedgehog_stir = /** @type {(inputs: Inclusive_Crisp_Hedgehog_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichtsversion nicht unterstützt`)
};

/**
* | output |
* | --- |
* | "Report version not supported" |
*
* @param {Inclusive_Crisp_Hedgehog_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inclusive_crisp_hedgehog_stir = /** @type {((inputs?: Inclusive_Crisp_Hedgehog_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Crisp_Hedgehog_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inclusive_crisp_hedgehog_stir(inputs)
	return de_inclusive_crisp_hedgehog_stir(inputs)
});